var header = function () {

	var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	var headerElement = document.querySelector('.js-header');
	var navListMobileContainerElement = document.querySelector('.js-nav-list-mobile-container');
	var scrollingDownCSSClass = 'scrolling-down';
	var scrollingUpCSSClass = 'scrolling-up';
	var activeLineElement = document.querySelector('.js-nav-active-line');
	var activeLineOverlap = 4;
	var activeLineResetTimer;

	function init() {
		if (!headerElement) {
			return;
		}
		searchBox();
		subNavigation();
		subNavigationHover();
		mobileNavLock();
        scrolling();
        checkUserLoginStatus();
		// prevents animations on immediate page load
		setTimeout(function () {
			headerElement.classList.remove('c-header--loading');
		}, 300);
	}

	function searchBox() {
		var searchFormElement = document.querySelector('.js-search-form');
		var searchFormInputElement = document.querySelector('.js-search-input');
		var searchText = document.querySelector('.js-search-text');
		var searchIcon = document.querySelector('.js-search-icon');
		var searchTriggerElement = document.querySelector('.js-search-trigger');
		if (!searchTriggerElement) {
			return;
		}
		searchTriggerElement.addEventListener('click', function () {
			var shouldOpen = searchFormElement.getAttribute('aria-hidden') === 'true';
			searchFormElement.setAttribute('aria-hidden', !shouldOpen);
			if (!shouldOpen) {
				searchText.textContent = "Open search form";
				searchIcon.querySelector('.js-search-icon-use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-search');
				searchFormInputElement.blur();
			} else {
				searchText.textContent = "Close search form";
				searchIcon.querySelector('.js-search-icon-use').setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#icon-close');
				searchFormInputElement.focus();
			}
			closeOpenSubNavs();
		});

	}

	function subNavigation() {

		var subNavTriggers = document.querySelectorAll('.js-nav-sub-link-trigger');

		for (var index = 0; index < subNavTriggers.length; index++) {
			(function (index) {
				var subNavTrigger = subNavTriggers[index];
				subNavTrigger.addEventListener('click', function (e) {
					e.preventDefault();
					closeOpenSubNavs(subNavTrigger);
					var targetSubNav = document.querySelector('#' + subNavTrigger.getAttribute('aria-controls'));
					var shouldBeExpanded = subNavTrigger.getAttribute('aria-expanded').toLowerCase() === 'false';

					if (!subNavTrigger.classList.contains('js-nav-mobile-trigger')) {
						if (shouldBeExpanded) {
							targetSubNav.style.maxHeight = targetSubNav.scrollHeight + 'px';
						} else {
							targetSubNav.removeAttribute('style');
						}	
					}

					subNavTrigger.setAttribute('aria-expanded', shouldBeExpanded + '');
					targetSubNav.setAttribute('aria-expanded', shouldBeExpanded + '');
				});
			}).call(this, index);

		}

	}

	function subNavigationHover() {
		var canHover = !matchMedia('(hover: none)').matches;
		if (canHover) {
			var subNavHoverTriggers = document.querySelectorAll('.js-nav-sub-hover');
			for (var index = 0; index < subNavHoverTriggers.length; index++) {
				(function (index) {
					var subNavHoverTrigger = subNavHoverTriggers[index];
					var subNavTrigger = subNavHoverTrigger.querySelector('.js-nav-sub-link-trigger');
					var noSubNav = subNavHoverTrigger.classList.contains('js-nav-no-sub-hover');
					var hoverIntentTimer;
					subNavHoverTrigger.addEventListener('mouseover', function (e) {
						e.preventDefault();
						animateNavLine(subNavHoverTrigger, !noSubNav);
						if (isDesktop()) {
							if (hoverIntentTimer) {
								clearTimeout(hoverIntentTimer);
							}
							if (activeLineResetTimer) {
								clearTimeout(activeLineResetTimer);
							}
							if (noSubNav) {
								return;
							}
							hoverIntentTimer = setTimeout(function () {
								var subNavAriaControls = subNavTrigger.getAttribute('aria-controls');
								if (!subNavAriaControls) {
									return;
								}

								var targetSubNav = document.querySelector('#' + subNavAriaControls);
								subNavTrigger.setAttribute('aria-expanded', 'true');
								targetSubNav.setAttribute('aria-expanded', 'true');
							}, 200);
						}
					});
					subNavHoverTrigger.addEventListener('mouseout', function (e) {
						e.preventDefault();
						if (isDesktop()) {
							if (hoverIntentTimer) {
								clearTimeout(hoverIntentTimer);
							}
							activeLineResetTimer = setTimeout(function () {
								resetActiveLine();
							}, 400);
							if (noSubNav) {
								return;
							}
							hoverIntentTimer = setTimeout(function () {
								var subNavAriaControls = subNavTrigger.getAttribute('aria-controls');
								if (!subNavAriaControls) {
									return;
								}

								var targetSubNav = document.querySelector('#' + subNavAriaControls);
								subNavTrigger.setAttribute('aria-expanded', 'false');
								targetSubNav.setAttribute('aria-expanded', 'false');							
							}, 200);
						}
					});
				}).call(this, index);
			}
		}
	}

	function closeOpenSubNavs(excludedElement) {
		var subNavTriggers = document.querySelectorAll('.js-nav-sub-link-trigger[aria-expanded="true"]:not(.js-nav-mobile-trigger)');
		for (var index = 0; index < subNavTriggers.length; index++) {
			(function (index) {
				var subNavTrigger = subNavTriggers[index];
				if (excludedElement && subNavTrigger.isEqualNode(excludedElement)) {
					return;
				}
				var targetSubNav = document.querySelector('#' + subNavTrigger.getAttribute('aria-controls'));
				targetSubNav.removeAttribute('style');
				subNavTrigger.setAttribute('aria-expanded', 'false');
				targetSubNav.setAttribute('aria-expanded', 'false');
			}).call(this, index);
		}
		navListMobileContainerElement.setAttribute('style', '');
	}

	function mobileNavLock() {
		var isMobileNavOpen = false;
		var mobileNavOpenCSSClass = 'mobile-nav-open';
		var scrollPosition = document.documentElement.scrollTop;
		document.querySelector('.js-nav-mobile-trigger').addEventListener('click', function () {
			isMobileNavOpen = !isMobileNavOpen;
			if (isMobileNavOpen) {
				scrollPosition = document.documentElement.scrollTop;
				document.documentElement.classList.add(mobileNavOpenCSSClass);
				window.addEventListener('resize', checkIfChangedToDesktopNav);
				navListMobileContainerElement.scrollTop = 0;
			} else {
				document.documentElement.classList.remove(mobileNavOpenCSSClass);
				window.scrollTo(0, scrollPosition);
				window.removeEventListener('resize', checkIfChangedToDesktopNav);
			}
		});

		var checkIfChangedToDesktopNav = debounce(function () {
			if (isDesktop()) {
				document.documentElement.classList.remove(mobileNavOpenCSSClass);
			} else {
				document.documentElement.classList.add(mobileNavOpenCSSClass);
			}
		}, 200);
	}

	function scrolling() {

		if (lastScrollTop > 0) {
			headerElement.classList.add(scrollingDownCSSClass);
			headerElement.classList.remove(scrollingUpCSSClass);
		}

		var debouncedScrollCheck = debounce(function () {
			window.requestAnimationFrame(function () {
				scrollCheck();
			});
		}, 50);

		window.addEventListener("touchmove", debouncedScrollCheck);
		window.addEventListener("scroll", debouncedScrollCheck);
		var tvContainerElement = document.querySelector('.js-tv-left-container');
		if (tvContainerElement) {
			var debouncedTvScrollCheck = debounce(function () {
				window.requestAnimationFrame(function () {
					scrollCheck(tvContainerElement);
				});
			}, 50);
			tvContainerElement.addEventListener("touchmove", debouncedTvScrollCheck);
			tvContainerElement.addEventListener("scroll", debouncedTvScrollCheck);
		}
		
	}

	function scrollCheck(elementToCheck) {
		var scrollTop = elementToCheck ? elementToCheck.scrollTop : (window.pageYOffset || document.documentElement.scrollTop);
		if (scrollTop === lastScrollTop) {
			return;
		}

		var headerHeight = headerElement.offsetHeight;

		if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
			headerElement.classList.add(scrollingDownCSSClass);
			headerElement.classList.remove(scrollingUpCSSClass);
			document.documentElement.classList.add(scrollingDownCSSClass);
			document.documentElement.classList.remove(scrollingUpCSSClass);
		} else {
			headerElement.classList.add(scrollingUpCSSClass);
			headerElement.classList.remove(scrollingDownCSSClass);
			document.documentElement.classList.add(scrollingUpCSSClass);
			document.documentElement.classList.remove(scrollingDownCSSClass);
		}
		if (isDesktop()) {
			closeOpenSubNavs();
		}
		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
	}

	function animateNavLine(activeElement, hasSubNav) {

		if (hasSubNav) {
			if (!isDesktop() || activeElement.querySelector('.js-nav-sub-link-trigger').classList.contains('js-nav-sub-link-trigger-no-line')) {
				return;
			}
		}

		var paddingLeftOfActiveLink = parseInt(window.getComputedStyle(activeElement, null).getPropertyValue('padding-left'));
		var paddingRightOfActiveLink = parseInt(window.getComputedStyle(activeElement, null).getPropertyValue('padding-right'));
		var positionOfActiveItem = activeElement.offsetLeft + paddingLeftOfActiveLink;
		var widthOfActiveItem = activeElement.getBoundingClientRect().width - paddingLeftOfActiveLink - paddingRightOfActiveLink;

		activeLineElement.style.transform = "skew(14deg) translateX(" + (positionOfActiveItem - activeLineOverlap) + "px)";
		activeLineElement.style.width = widthOfActiveItem + (activeLineOverlap * 2) + "px";
	}

	function resetActiveLine() {
		activeLineElement.setAttribute('style', '');
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	function isDesktop() {
		return window.matchMedia('(min-width: 768px)').matches;
    }

    function checkUserLoginStatus() {
        fetch("/api/sso")
            .then(function (response) {
                if (response.status === 200) {
                    return response;
                }
                if (response.status === 404) {
                    throw new Error('User not logged in.');
                } else {
                    throw new Error('An error occurred getting user logged in state.');
                }
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                renderAccountLoggedInState(data);
                triggerEvent(data);
            })
            .catch(function (error) { });
    }

    function createCustomEventForDispatch(eventName, data) {

        let event;
        if (window.CustomEvent && typeof window.CustomEvent === 'function') {
            event = new CustomEvent(eventName, { detail: data });
        } else {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, true, true, data);
        }

        return event;

    }

    function triggerEvent(data) {

        const loggedInEvent = createCustomEventForDispatch('userLoggedIn', data);
        document.dispatchEvent(loggedInEvent);

    }

    function renderAccountLoggedInState(data) {
        var headerLinksContainerElement = document.querySelector('.js-header-account-links');
        if (headerLinksContainerElement) {
            headerLinksContainerElement.outerHTML = `
            <ul class="c-eyebrow-bar__nav-list c-eyebrow-bar__nav-list--alt">
                <li class="c-eyebrow-bar__nav-item">
                    <a href="${data.accountUrl}" class="c-eyebrow-bar__nav-link c-eyebrow-bar__nav-link--icon">
                        <span class="u-visuallyhidden">Go to your Wolves account</span>
                        <span class="c-eyebrow-bar__nav-link-text">
                            <svg class="c-eyebrow-bar__icon-link c-eyebrow-bar__icon-link--avatar">
                                <use xlink:href="#icon-avatar"></use>
                            </svg>
                        </span>
                    </a>
                </li>
            </ul>
            `;
        }
    }

	return {
		init: init
	};

}();

header.init();
